import Service from "../../service";

const filterInvoice = {
    getFilterInvoice(driver_id,date) {
        return Service.get("/filter-invoice?" +
            "driver_id="+driver_id+
            "&date="+date
        );
    },
    showDriverDetailsByDriverId(driver_id,page){
        return Service.get("/driver-details/"+driver_id+'?page='+page)
    },
    saveDriverDetails(data){
        return Service.post("/driver-details",data);
    },
    updateDriverDetails(data){
        return Service.put("/driver-details/"+data.driver_details_id,data);
    },
    deleteDriverDetails(id){
        return Service.delete("/driver-details/"+id);
    },
    deleteDriverTransport(id){
        return Service.delete("/driver-transport-report/"+id);
    },
    driverShippingMonth(driver_id,date,transportation_id,transport_fee){
        return Service.get("/driver_shipping_month?driver_id="+driver_id+
            '&date='+date+
            '&transportation_id='+transportation_id+
            '&transport_fee='+transport_fee
        );
    },
    showDriverDetailsById(id){
        return Service.get('/get-driver-details?id='+id) ;
    },
    getInvoiceFromDriver(driver_id){
        return Service.get(`/invoice_from_driver?&driver_id=${driver_id}`) ;
    },
    getCarFeeDriver(data){
        return Service.get(`/get-car-fee-driver?page=${data.page}&driver_id=${data.driver_id}`) ;
    },

    //รายงานค่าเที่ยว
    getDriverTransportReport(data){
        return Service.get('/driver-transport-report?page=' + data.page +
            '&start_date='+data.start_date+
            '&end_date='+data.end_date);
    },
    showDriverTransportReport(id){
        return Service.get('/driver-transport-report/'+id);
    },
    editDriverTransportReport(id,data){
        return Service.put('/driver-transport-report/'+id,data);
    },
    createDriverTransportReport(data){
        return Service.post('/driver-transport-report',data);
    },
    getBalanceDriverTransport(){
        return Service.get('/get_balance_driver_transport');
    }

};
export default filterInvoice;
